import { render, staticRenderFns } from "./Inventories.vue?vue&type=template&id=5ee50342"
import script from "./Inventories.vue?vue&type=script&lang=ts"
export * from "./Inventories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports